// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"326":"proximity","594":"about"}[chunkId] + "." + {"326":"d2b7c4c7","594":"5b57fc92"}[chunkId] + ".js";
};